import { BLOCK_TYPES, IPage, IPageBlock } from '../../../page';
import { IHDYHAU } from '../../hdyhau';

export function useHDYHAU (page: IPage | null): IHDYHAU | null {
    if (page === null) {
        return null;
    }

    const hdyhauBlock: IPageBlock | undefined = page.blocks.find((block: IPageBlock): boolean => {
        return block.type === BLOCK_TYPES.HDYHAU;
    });

    if (hdyhauBlock === undefined || hdyhauBlock.type !== BLOCK_TYPES.HDYHAU) {
        return null;
    }

    return hdyhauBlock.content;
}
